import {createUseStyles} from 'react-jss';
import {Theme} from '../themes/default';

const useCinnamonArtStyles = createUseStyles((theme: Theme) => {
    return {
        container: {
            backgroundColor: theme.palette.primary.light,
            fontFamily: theme.fonts.apex,
            minHeight: '90vh',
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'center',
            padding: theme.spacing(4),
            color: theme.colors.espresso_brown,
        },
        titleSection: {
            textAlign: 'center',
            marginBottom: theme.spacing(8),
            maxWidth: '900px',
            marginTop: theme.spacing(5),
        },
        mainTitle: {
            fontFamily: theme.fonts.poplar,
            fontSize: '4rem',
            color: theme.colors.espresso_brown,
            margin: 0,
            lineHeight: 1.1,
            textShadow: '2px 2px 4px rgba(0,0,0,0.1)',
            [theme.breakpoints.down('md')]: {
                fontSize: '2.5rem',
            },
            [theme.breakpoints.down('sm')]: {
                fontSize: '2rem',
            },
        },
        subtitle: {
            fontFamily: theme.fonts.poplar,
            fontSize: '4rem',
            color: theme.colors.espresso_brown,
            margin: 0,
            lineHeight: 1.1,
            marginTop: theme.spacing(1),
            [theme.breakpoints.down('md')]: {
                fontSize: '2.5rem',
            },
            [theme.breakpoints.down('sm')]: {
                fontSize: '2rem',
            },
        },
        formulaContainer: {
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            gap: theme.spacing(4),
            marginBottom: theme.spacing(8),
            flexWrap: 'wrap',
            [theme.breakpoints.down('md')]: {
                gap: theme.spacing(2),
                marginBottom: theme.spacing(6),
            },
            [theme.breakpoints.down('sm')]: {
                flexDirection: 'column',
                gap: theme.spacing(2),
                alignItems: 'center',
            },
        },
        // First row on mobile: icon1 + icon2 +
        firstRow: {
            display: 'none',
            [theme.breakpoints.down('sm')]: {
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                gap: theme.spacing(2),
                marginBottom: theme.spacing(1),
            },
        },
        // Second row on mobile: icon3 = icon4
        secondRow: {
            display: 'none',
            [theme.breakpoints.down('sm')]: {
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                gap: theme.spacing(2),
            },
        },
        beerIcon: {
            width: '120px',
            height: 'auto',
            transition: 'transform 0.3s ease',
            '&:hover': {
                transform: 'scale(1.05)',
            },
            [theme.breakpoints.down('md')]: {
                width: '100px',
            },
            [theme.breakpoints.down('sm')]: {
                width: '80px',
            },
        },
        operator: {
            fontSize: '4rem',
            fontWeight: 'bold',
            color: theme.colors.espresso_brown,
            fontFamily: theme.fonts.poplar,
            [theme.breakpoints.down('md')]: {
                fontSize: '3rem',
            },
            [theme.breakpoints.down('sm')]: {
                fontSize: '2rem',
            },
        },
        // Hide desktop formula on mobile
        desktopFormula: {
            display: 'flex',
            alignItems: 'center',
            gap: theme.spacing(4),
            [theme.breakpoints.down('md')]: {
                gap: theme.spacing(2),
            },
            [theme.breakpoints.down('sm')]: {
                display: 'none',
            },
        },
        descriptionSection: {
            textAlign: 'center',
            maxWidth: '800px',
            padding: theme.spacing(4),
            borderRadius: '20px',
            [theme.breakpoints.down('md')]: {
                padding: theme.spacing(3),
                maxWidth: '90%',
            },
        },
        descriptionText: {
            fontSize: '1.3rem',
            lineHeight: 1.6,
            color: theme.colors.espresso_brown,
            fontWeight: 'bold',
            margin: 0,
            [theme.breakpoints.down('md')]: {
                fontSize: '1.1rem',
            },
            [theme.breakpoints.down('sm')]: {
                fontSize: '1rem',
            },
        },
        highlightText: {
            fontWeight: 'bold',
            color: theme.colors.dark_chocolate,
        },
    };
});

export default useCinnamonArtStyles;